import { useContext } from 'react'

import { SeriesContext } from '../providers/SeriesProvider'

export const useSeriesContext = () => {
  const seriesContext = useContext(SeriesContext)

  if (seriesContext === undefined) {
    throw new Error('seriesContext must be used within a SeriesProvider')
  }

  return seriesContext
}
